import { css } from "lit";

export const style = css`
	:host {
		display: flex;
		position: relative;
		flex-direction: column;
		height: 100%;
	}

	* {
		box-sizing: border-box;
	}

	.controls {
		display: flex;
		flex-direction: row;
		align-items: center;
		flex: 0;
		border-bottom: 1px solid var(--og-border-color);
	}

	.body {
		flex: 1;
	}

	og-accordion {
		height: 100%;
		max-width: 500px;
	}

	.empty {
		padding-left: 16px;
	}
`;

export const itemStyle = css`

	table {
		width: 100%;
	}

	.item {
		border-bottom: 1px solid var(--og-border-color);
		line-height: normal !important;
	}

	.object-line-1 {
		display: flex;
		flex-direction: row;
		padding: 0 4px;
		height: 18px;
	}

	.object-line-2 {
		padding: 0 4px;
	}

	.object-name {
		flex: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-weight: bold;
		align-content: flex-end;
	}

	.object-select, .object-menu {
		flex: 0;
		text-align: center;
	}

	og-form-checkbox {
		margin-top: 4px;
	}

	og-dropdown-menu {
		margin-top: 2px;
	}
`;
